// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"51775cd9","338":"eb0219cc","342":"fa57d681","453":"1f960028","478":"1015de5e","637":"32aa4f19"}[chunkId] + ".chunk.js";
};